import { useMemo } from "react";
import {
  InternalAdminTagCategoryListInput,
  InternalAdminTagCategoryListQuery,
  InternalAdminTagCategoryListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_TAG_CATEGORY_LIST_QUERY from "../_networking/internal-admin-tag-category-list";

interface IProps {
  organizationId?: string;
  input: InternalAdminTagCategoryListInput;
}

const useInternalAdminTagCategoryList = ({ organizationId, input }: IProps) => {
  const { data, loading, refetch } = useQuery<
    InternalAdminTagCategoryListQuery,
    InternalAdminTagCategoryListQueryVariables
  >(INTERNAL_ADMIN_TAG_CATEGORY_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: organizationId
      ? {
          organizationId,
          input,
        }
      : undefined,
    skip: !organizationId,
  });

  const tagCategories = useMemo(() => {
    if (!data) return [];
    return data.internalAdminTagCategoryList;
  }, [data]);

  return {
    tagCategories,
    loading,
    refetch,
  };
};

export default useInternalAdminTagCategoryList;
